import { useState } from 'react';
import { ChatBubble, GreetingBubble } from '../ChatBubble';
import FastfiveEntryButtons from './FastfiveEntryButtons';
import { redirectToPage } from '../../utils/utils';
import buttonStyles from '../../style/styles/Buttons.module.css';

/**
 * fastfive 채팅의 entry 화면.
 * - main greeting + 5 entry 버튼 두 가지만 노출되는 정적 뷰.
 * - 시나리오가 선택되거나 messages 가 쌓이는 순간 Chat 으로 전환됨 (Chat.jsx 의 조기 분기).
 *
 * redirect 시나리오(lounge 등) 클릭 시 처리:
 *   - 해당 시나리오의 greetingMessage 를 챗봇 버블로 노출하고, 그 아래에 CTA 버튼을 붙임.
 *   - 사용자가 CTA 버튼을 클릭할 때만 redirectToPage. (자동 리다이렉트 X)
 *   - greetingMessage 가 없으면 CTA 없이 즉시 redirect (fallback).
 *   - CTA 버튼 라벨은 scenario.redirectButtonText 우선, 없으면 `${label} 보러가기` 로 fallback.
 */
const FastfiveEntryView = () => {
    const [pendingRedirect, setPendingRedirect] = useState(null);

    const handlePendingRedirect = (scenario) => {
        // greetingMessage 없으면 안내할 것도 없으므로 즉시 redirect
        if (!scenario?.greetingMessage) {
            if (scenario?.redirectUrl) redirectToPage(scenario.redirectUrl);
            return;
        }
        setPendingRedirect(scenario);
    };

    const handleRedirectClick = () => {
        if (pendingRedirect?.redirectUrl) {
            redirectToPage(pendingRedirect.redirectUrl);
        }
    };

    const redirectButtonText = pendingRedirect?.redirectButtonText
        || (pendingRedirect?.label ? `${pendingRedirect.label} 보러가기` : '보러가기');

    return (
        <div
            style={{
                width: '100%',
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                padding: '8px 0',
                overflow: 'auto',
                overscrollBehavior: 'contain',
            }}
        >
            {/* pending redirect 진행 중에는 메인 greeting 과 entry 버튼을 모두 숨김 —
                scenario flow 의 greeting 대체 동작과 일관성 유지 */}
            {!pendingRedirect && (
                <>
                    <GreetingBubble />
                    <FastfiveEntryButtons onPendingRedirect={handlePendingRedirect} />
                </>
            )}
            {pendingRedirect?.greetingMessage && (
                <>
                    <ChatBubble
                        message={{ message: pendingRedirect.greetingMessage, isChatbot: true }}
                    />
                    <div
                        className={buttonStyles.TailBubble__buttonWrapper}
                        style={{ justifyContent: 'flex-end' }}
                    >
                        <button
                            type="button"
                            className={buttonStyles.TailBubble__button}
                            onClick={handleRedirectClick}
                        >
                            <p className="h4">{redirectButtonText}</p>
                        </button>
                    </div>
                </>
            )}
        </div>
    );
};

export default FastfiveEntryView;
